const content: { [key: string]: any } = {
  applicationList: 'Applications',
};

export default content;
